import * as yup from 'yup';
import { checkoutSchema as checkout } from './checkout';
import {
  userInfoSchema as user_info_question,
  pupInfoSchema as pup_info_question,
  birthdaySchema as birthday_question,
  breedSchema as breed_question,
  caloriesSchema as calories_question,
  activitySchema as activity_question,
  allergiesSchema as allergies_question,
  poopSchema as poop_question,
  aboutSchema as about_form,
  nutritionSchema as nutrition_form,
  quizNextButtonSchema as quiz_next_button,
  weightInterstitialSchema as weight_interstitial,
} from './quiz';
import {
  planSelectionSchema as plan_selection,
  planSelectionSchema as product_type,
  recommendedPlanSchema as recommended_plan,
} from './plan';
import { addonSchema as extras } from './addons';
import { confirmationSchema as confirmation } from './confirmation';
import { appConfirmationSchema as app_confirmation } from './app_confirmation';

const redirect_route = yup.object({});

export {
  redirect_route,
  user_info_question,
  pup_info_question,
  birthday_question,
  breed_question,
  calories_question,
  activity_question,
  allergies_question,
  poop_question,
  recommended_plan,
  plan_selection,
  product_type,
  extras,
  checkout,
  confirmation,
  about_form,
  nutrition_form,
  app_confirmation,
  quiz_next_button,
  weight_interstitial,
};
